"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadLayer = void 0;
const registry_call_1 = require("./registry-call");
const contentTypes = require("./content-types");
async function downloadLayer(output, registryBase, repo, digest, username, password, options = {}, callChainObserver = { visitedUrls: [] }) {
    var _a;
    const accept = `${(_a = options.acceptLayer) !== null && _a !== void 0 ? _a : contentTypes.LAYER}`;
    const endpoint = `/${repo}/blobs/${digest}`;
    options = Object.assign({ json: false, encoding: null, snykInternalOutputStream: output }, options);
    const layerResponse = await (0, registry_call_1.registryV2Call)(registryBase, endpoint, accept, callChainObserver, username, password, options);
    return layerResponse;
}
exports.downloadLayer = downloadLayer;
//# sourceMappingURL=download-layer.js.map